export var DefinitionType;
(function (DefinitionType) {
    DefinitionType["Flow"] = "flow";
    DefinitionType["Blueprint"] = "blueprint";
    DefinitionType["Action"] = "action";
    DefinitionType["Trigger"] = "trigger";
    DefinitionType["Connection"] = "connection";
    DefinitionType["Type"] = "type";
})(DefinitionType || (DefinitionType = {}));
//# sourceMappingURL=definitions.js.map